import 'react-app-polyfill/ie11';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './i18n';
import HomePage from './HomePage';
import AmazonOAuthCallback from './components/Onboarding/AmazonOAuthCallback';
import MaintenancePage from './components/Common/MaintenancePage';
import { HashRouter } from 'react-router-dom'
import { captureOpenAIAttribution } from './utils/openaiAttribution';

//import * as serviceWorker from './serviceWorker';

const forwardLinkedInCallback = () => {
    const params = new URLSearchParams(window.location.search);
    const isLinkedInCallback = params.get('linkedin_oauth') === '1';

    if (isLinkedInCallback && window.opener) {
        window.opener.postMessage({
            type: 'linkedin_oauth_callback',
            code: params.get('code'),
            state: params.get('state'),
            error: params.get('error'),
            errorDescription: params.get('error_description')
        }, window.location.origin);
        window.close();
    }
};

forwardLinkedInCallback();
// Before the router mounts, so an ad reference in the landing URL is kept.
captureOpenAIAttribution();

// loading component for suspense fallback
const Loader = () => (
    <div className="splash-screen">
        <div className="splash-container">
            <div className="splash-double-bounce1"></div>
            <div className="splash-double-bounce2"></div>
        </div>
    </div>
);

// Amazon's OAuth redirect (https://app.pricerest.com/amazon/callback) is a
// real top-level navigation to this exact PATH, with no hash -- but the rest
// of this app navigates entirely through HashRouter, whose <Route>s only
// ever match the hash portion of the URL (see HomePage.js), which is empty
// here. server.js's catch-all serves this same index.html for that path like
// any other, so rather than trying to make an empty-hash load match a route,
// the real pathname is checked BEFORE the router even mounts, and the
// callback page renders standalone in its place when it matches -- see
// AmazonOAuthCallback.js, which reads spapi_oauth_code/state/
// selling_partner_id from window.location.search itself.
const isAmazonOAuthCallback = window.location.pathname === '/amazon/callback';

// MaintenancePage renders nothing until a backend call answers 503
// {"code": "maintenance"}; it then covers whatever is on screen, the signed-out
// screens included (see utils/maintenance.js).
ReactDOM.render(
    isAmazonOAuthCallback
        ? <Suspense fallback={<Loader />}>
              <AmazonOAuthCallback />
              <MaintenancePage />
          </Suspense>
        : <HashRouter>
              <Suspense fallback={<Loader />}>
                  <HomePage />
                  <MaintenancePage />
              </Suspense>
          </HashRouter>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();
